<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Add Test

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="modal-body padding-top-0px">








            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">




                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="firstName" class="margin-bottom-0px margin-top-5px">Test</label>
                      </div>
                      <div class="col-md-6 padding-right-8px" *ngIf="Typeofscreen=='Scan' && TcModelName!=='Fet' ">
                        <CustomDataByRequestType RequestedType="IvfFolScanDayTests" ActorCode={{ActorCode}}
                                                 id="CurrentSaveIvfCycleTestDataRequest.TestCode" SelectedValue=""
                                                 [(ngModel)]="CurrentSaveIvfCycleTestDataRequest.TestCode" (keyChange)="onAssignedToActorCode($event)"
                                                 name="CurrentSaveIvfCycleTestDataRequest.TestCode" required>
                        </CustomDataByRequestType>
                      </div>
                      <div class="col-md-6 padding-right-8px" *ngIf="Typeofscreen=='Pickup' && TcModelName!=='Fet' ">
                        <CustomDataByRequestType RequestedType="IvfPickupDayTests" ActorCode={{ActorCode}}
                                                 id="CurrentSaveIvfCycleTestDataRequest.TestCode" SelectedValue=""
                                                 [(ngModel)]="CurrentSaveIvfCycleTestDataRequest.TestCode" (keyChange)="onAssignedToActorCode($event)"
                                                 name="CurrentSaveIvfCycleTestDataRequest.TestCode" required>
                        </CustomDataByRequestType>
                      </div>
                      <div class="col-md-6 padding-right-8px" *ngIf="Typeofscreen=='PregTr' && TcModelName!=='Fet' ">
                        <CustomDataByRequestType RequestedType="IvfPregTests" ActorCode={{ActorCode}}
                                                 id="CurrentSaveIvfCycleTestDataRequest.TestCode" SelectedValue=""
                                                 [(ngModel)]="CurrentSaveIvfCycleTestDataRequest.TestCode" (keyChange)="onAssignedToActorCode($event)"
                                                 name="CurrentSaveIvfCycleTestDataRequest.TestCode" required>
                        </CustomDataByRequestType>
                      </div>
                      <div class="col-md-6 padding-right-8px" *ngIf="Typeofscreen=='Et' && TcModelName!=='Fet' ">
                        <CustomDataByRequestType RequestedType="IvfEtDayTests" ActorCode={{ActorCode}}
                                                 id="CurrentSaveIvfCycleTestDataRequest.TestCode" SelectedValue=""
                                                 [(ngModel)]="CurrentSaveIvfCycleTestDataRequest.TestCode" (keyChange)="onAssignedToActorCode($event)"
                                                 name="CurrentSaveIvfCycleTestDataRequest.TestCode" required>
                        </CustomDataByRequestType>
                      </div>

                      <div class="col-md-6 padding-right-8px" *ngIf="Typeofscreen=='Scan' && TcModelName =='Fet'">
                        <CustomDataByRequestType RequestedType="IvfFolScanDayTests" ActorCode={{ActorCode}}
                                                 id="CurrentSaveIvfCycleTestDataRequest.TestCode" SelectedValue=""
                                                 [(ngModel)]="CurrentSaveIvfCycleTestDataRequest.TestCode" (keyChange)="onAssignedToActorCode($event)"
                                                 name="CurrentSaveIvfCycleTestDataRequest.TestCode" required>
                        </CustomDataByRequestType>
                      </div>
                      <div class="col-md-6 padding-right-8px" *ngIf="Typeofscreen=='Et' && TcModelName =='Fet'">
                        <CustomDataByRequestType RequestedType="IvfEtDayTests" ActorCode={{ActorCode}}
                                                 id="CurrentSaveIvfCycleTestDataRequest.TestCode" SelectedValue=""
                                                 [(ngModel)]="CurrentSaveIvfCycleTestDataRequest.TestCode" (keyChange)="onAssignedToActorCode($event)"
                                                 name="CurrentSaveIvfCycleTestDataRequest.TestCode" required>
                        </CustomDataByRequestType>
                      </div>

                    </div>

                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right ">
                        <label for="diaplayName">Result </label>
                      </div>
                      <div class="col-md-4 col-6">


                        <input type="text" class="form-control" placeholder="Result"
                               id="CurrentSaveIvfCycleTestDataRequest.Result"
                               [(ngModel)]="CurrentSaveIvfCycleTestDataRequest.Result"
                               name="CurrentSaveIvfCycleTestDataRequest.Result" #Endometrium="ngModel"
                               maxlength="5" pattern="^[\0-9,._\-?]*$"  required>
                        <small class="form-text text-danger"
                               *ngIf="(!Endometrium.valid && (Endometrium.dirty || Endometrium.touched) && Endometrium.errors.required )"></small>
                        <small class="form-text text-danger"
                               *ngIf="(!Endometrium.valid && Endometrium.errors.pattern)">(only numbers are allowed)</small>
                      </div>
                      <div class="col-md-2 col-3 padding-right-6px padding-left-9px">
                        <CodeTypeValue CodeType="BDTUT"
                                       id="CurrentSaveIvfCycleTestDataRequest.ResultUnits"
                                       [(ngModel)]="CurrentSaveIvfCycleTestDataRequest.ResultUnits" SelectedValue="FollicularScanEndInfo.EndometriumThicknessUnits"
                                       name="CurrentSaveIvfCycleTestDataRequest.ResultUnits">
                        </CodeTypeValue>


                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right ">
                        <label for="diaplayName">Comments </label>
                      </div>
                      <div class="col-md-6 padding-right-8px ">
                        <!--<CodeTypeValue CodeType="MARTL"></CodeTypeValue>-->

                        <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Comments"
                                  name="CurrentSaveIvfCycleTestDataRequest.Remarks"
                                  [(ngModel)]="CurrentSaveIvfCycleTestDataRequest.Remarks" required minlength="1" maxlength="100"
                                  #addconcerns_text="ngModel"></textarea>
                        <small class="form-text text-danger"
                               *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))"></small>
                      </div>
                    </div>


                  </div>
                </div>




              </div>
            </div>




















          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit"  class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
